import { render, staticRenderFns } from "./HolidaysDetails.vue?vue&type=template&id=e4ea6a6e"
import script from "./HolidaysDetails.vue?vue&type=script&lang=js"
export * from "./HolidaysDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports